export enum TimeFormatKinds {
  Colon12hEn,
  Colon24h,
  String12hEn,
  String12hJa,
  String24h,
  Colon12h,
  String12h,
}
